module.exports = __webpack_public_path__ + "static/assets/0835e845199079657721d184dba19f61.svg";